module.exports = __webpack_public_path__ + "img/gb809.prt.be5e84e7.jpg";